define('app/views/checkout_login_container_view',['app/setup'], function(takhfifan) {
  takhfifan.checkoutLoginContainerView= Backbone.View.extend({
    initialize: function(options) {
      takhfifan.eventHub.on('checkout:payment', function() {
        this.$el.hide();
      }, this);
      takhfifan.eventHub.on('checkout:shipping', function() {
        this.$el.hide();
      }, this);
      takhfifan.eventHub.on('checkout:login', function() {
        this.$el.show();
      }, this);

      takhfifan.eventHub.on('formkey', function(formKey) {
        this.$el.removeClass('disable');
      }, this);

    },
  });
});

